<script lang="ts">
  import type { SelectionReadManyResponse } from '@entities/selection';

  import CardTemplate from './card-template.svelte';

  export let item: SelectionReadManyResponse;
</script>

<CardTemplate cover="{item.cover}" slug="{item.slug}" title="{item.title}">
  <span class="mb-1 text-lg font-semibold" slot="title">
    {item.title}
  </span>

  <div class="text-dark-700" slot="total-count">
    {item.art_assets_count} Artworks
  </div>
</CardTemplate>
